// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"c060159d","295":"728fbe14","362":"3fddd637","574":"5b8631bd","807":"35b60edc","818":"9ea9ab3f","899":"50cc9cac","900":"a9fb9ee5","996":"e535af0b"}[chunkId] + ".chunk.js";
};